import './styles/App.css';
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRouter from "./components/AppRouter";
import SideBar from "./components/UI/SideBar/SideBar";
import Header from "./components/UI/Header/Header";
import {useEffect, useState} from "react";
import {AuthContext} from "./context";
import Service from "./API/Service";

// чтобы посмотреть Login
function AppWrapper() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
    const isProfilePage = location.pathname === "/profile";
    const [uploadState, setUploadState] = useState('')
    const [isAuth, setIsAuth] = useState(localStorage.getItem("auth") === "true");

    const logout = async () => {
        setIsAuth(false);
        await Service.pushLogout();
        localStorage.removeItem('auth')
    }

    // useEffect(() => {
    //     setIsAuth(!!localStorage.getItem("token"));
    // }, [isAuth]);

  return (
      <AuthContext.Provider value={{
          isAuth,
          setIsAuth,
          logout,
          uploadState,
          setUploadState,
      }}>
          <div style={{ display: 'flex', gap: 31, width: '100%'}}>
              {!isLoginPage && !isProfilePage && <SideBar />}
              <div style={{ display: 'flex', flexDirection: 'column', ...(isProfilePage ? {width: '90%', margin: 'auto'} : { width: 1025 }) }}>
                  {!isLoginPage && <Header />}
                  <AppRouter />
              </div>
          </div>
      </AuthContext.Provider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

export default App;
